var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ItemList',{attrs:{"list":_vm.renderMenuList,"level":0}}),_c('GroupList',{attrs:{"list":_vm.renderNavigationMenuList,"level":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }